module.exports = __webpack_public_path__ + "img/logo-mingya.7a3dec2c.png";